import { createContext, useContext } from 'react';

type SplitContext = {
  client: Promise<SplitIO.IClient | undefined> | null;
  updateUserId: (id: string) => void;
};

const defaultValue: SplitContext = {
  client: null,
  updateUserId: () => {},
};

const context = createContext(defaultValue);
const { Provider } = context;
const useSplit = (): SplitContext => useContext(context);

export { SplitContext, Provider, defaultValue, useSplit };
